import axios from 'axios';
import { GET_TRANSACTIONS, LOADING, TABLE_LOADING, SAVE_SEARCH_PARAM, SAVE_PAGINATION_DATA, SAVE_PORTAL_USER, GET_BULK_TRANSACTIONS, GET_BULK_TRANSACTIONS_BY_ID, SAVE_PAGINATION_DATA_FOR_VIEW_BULK_BY_ID, BULK_VIEW_LOADING } from '../types';
import moment from "moment"

// const BASE_URL = 'https://quickteller-innovation.k8.isw.la';
// const xsrf = "345b5498-728e-4c44-b633-fc184f1000b8";

const BASE_URL = '/qr-transaction-portal-api';
const xsrf = document.getElementById("csrf-token").getAttribute("content");

const email = 'support@interswitchgroup.com';

const uatHeader = {
    'email': email,
    'Content-Type': 'application/json',
    'terminalId': '3IWP0001',
    'X-XSRF-TOKEN': xsrf
}

const prodHeader = {
    'email': email,
    'terminalId': '3QTI0001',
    'Content-Type': 'application/json',
    'X-XSRF-TOKEN': xsrf
}


export const getPortalUser = () => dispatch => {
    axios.get(`/api/v1/user`).then(function (response) {
        const portalUser = {
            id: response.data.id,
            email: response.data.email
        }
        dispatch(savePortalUser(portalUser));
    }).catch(function (error) {
        console.log("get portal user ERR: ", error);
    });
}

export const getTransactions = (payload) => dispatch => {
    dispatch(setLoading(true));
    axios.get(`${BASE_URL}/api/v1/qranalytics`, {
        params: {
            transactionReference: payload?.data?.transactionReference,
            customerId: payload?.data?.customerId,
            paymentReference: payload?.data?.paymentReference,
            customerEmail: payload?.data?.customerEmail,
            status: payload?.data?.status,
            endDate: payload?.data?.endDate,
            startDate: payload?.data?.startDate,
            pageNo: payload?.data?.pageNo,
            pageSize: payload?.data?.pageSize
        },
        headers: window.location.origin === 'https://portal.interswitchgroup.com' ? prodHeader : uatHeader
    })
        .then(function (response) {
            let tableData = response.data.pageData.map((data, key) => {
                return {
                    key,
                    amount: parseFloat(data.amount / 100).toFixed(2) || '--',
                    email: data.customerEmail || '--',
                    transactionType: data.webPayTransactionType || '--',
                    qtResponseCode: data.qtResponseCode || '--',
                    webpayResponseCode: data.webPayResponseCode || '--',
                    transactionRef: data.transactionRef || '--',
                    customerId: data.customerId || '--',
                    status: data.status || '--',
                    transactionResponse: data.webPayResponseDescription || '--',
                    date: data.dateOfPayment || '--',
                    reversalStatus: data.reversalStatus || '--',
                    reversalResponseDescription: data.reversalResponseDescription || '--',
                    isRepushable: data.isRepushable,
                    isReversable: data.isReversable
                }
            });

            const paginationData = {
                pageCount: response.data.pageCount,
                pageSize: response.data.pageSize,
                pageNo: response.data.pageNo,
                dataSize: response.data.dataSize,
            }
            dispatch(saveTransactions(tableData));
            dispatch(saveSearchParam(payload.data));
            dispatch(savePaginationData(paginationData));
        })
        .catch(function (error) {
            dispatch(setLoading(false));
            payload.failAction();
        });
}

export const sendQrAdvice = (payload) => dispatch => {
    dispatch(tableLoading(true));
    axios.post(`${BASE_URL}/api/v1/payments/qr/send-advice`,
        payload.data,
        { headers: window.location.origin === 'https://portal.interswitchgroup.com' ? prodHeader : uatHeader }
    ).then((response) => {
       
        payload.successAdviceAction(response.data.responseDescription);
    }).catch((error) => {
        dispatch(tableLoading(false));
        if (error.response) {
            payload.failAdviceAction(error.response.data.description);
        } else {
            payload.failAdviceAction("Unable to process request at the moment");
        }
    });
}

export const sendQrReversal = (payload) => dispatch => {
    dispatch(setLoading(true));
    axios.get(`${BASE_URL}/api/v1/payments/pay-with-transfer/reversal?transactionReference=${payload.transactionRef}&email=${payload.userEmail}`,
        { headers: window.location.origin === 'https://portal.interswitchgroup.com' ? prodHeader : uatHeader }
    ).then((response) => {
        payload.successAdviceAction(response.data.responseDescription);
    }).catch((error) => {
        dispatch(setLoading(false));
        if (error.response) {
            payload.failAdviceAction(error.response.data.description || "Unable to process request at the moment");
        } else {
            payload.failAdviceAction("Unable to process request at the moment");
        }
    });
}

export const getBulkReversals = (payload) => dispatch => {
    dispatch(setLoading(true));
    axios.get(`${BASE_URL}/api/v1/qranalytics/GetBulkReversals`, {
        params: {
            pageNo: payload?.data?.pageNo || 1,
            pageSize: payload?.data?.pageSize || 10
        },
        headers: window.location.origin === 'https://portal.interswitchgroup.com' ? prodHeader : uatHeader
    })
        .then(function (response) {
            let tableData = response.data.pageData.map((data, key) => {
                return {
                    key,
                    uploadedBy: data.uploadedBy || '--',
                    processedCount: data.processedCount || '--',
                    previouslyReversedCount: data.previouslyReversedCount || '--',
                    invalidCount: data.invalidCount || '--',
                    failedCount: data.failedCount || '--',
                    dateUploaded: moment(data.dateUploaded).format("MM/DD/YYYY HH:MM") || '--',
                    count: data.count || '--',
                    batchId: data.batchId || '--'
                }
            });

            const paginationData = {
                pageCount: response.data.pageCount,
                pageSize: response.data.pageSize,
                pageNo: response.data.pageNo,
                dataSize: response.data.dataSize,
            }
            dispatch(saveBulkTransactions(tableData));
            dispatch(savePaginationData(paginationData));
        })
        .catch(function (error) {
            dispatch(setLoading(false));
            payload.failAction();
        });
}

    export const postBulkReversal = (body) => dispatch => {

    axios.post(`${BASE_URL}/api/v1/payments/pay-with-transfer/bulk-reversal`,  body.data,
        { headers: window.location.origin === 'https://portal.interswitchgroup.com' ? prodHeader : uatHeader }).then(function (response) {
            body.successBulkReversalAction(response?.data?.responseDescription);
        }).catch(function (error) {
             dispatch(setLoading(false));
             if (error.response) {
                body.failBulkReversalAction(error.response.data.description || "Unable to process request at the moment");
             } else {
                body.failBulkReversalAction("Unable to process request at the moment");
             }
        });
    }

 export const getBulkreversalByID = (payload, callback) => dispatch => {
    dispatch(setForBulkViewLoading(true));
    axios.get(`${BASE_URL}/api/v1/qranalytics/GetBulkReversalsDetails`, {
        params: {
            batchId: payload?.data?.batchId || '',
            pageNo: payload?.data?.pageNo || 1,
            pageSize: payload?.data?.pageSize || 10
        },
        headers: window.location.origin === 'https://portal.interswitchgroup.com' ? prodHeader : uatHeader
    })
        .then(function (response) {
            dispatch(setForBulkViewLoading(false));
            let tableData = response.data.pageData.map((data, key) => {
                return {
                    key,
                    paymentCode: data.paymentCode || "--",
                    amount: data.amount || "--",
                    customerId: data.customerId || "--",
                    customerName: data.customerName || "--",
                    customerEmail: data.customerEmail || "--",
                    customerMobile: data.customerMobile || "--",
                    pageFlowValues: data.pageFlowValues || "--",
                    paymentMode: data.paymentMode || "--",
                    deviceId: data.deviceId || "--",
                    qtResponseCode: data.qtResponseCode || "--",
                    webPayResponseCode: data.webPayResponseCode || "--",
                    status: data.status || "--",
                    transactionRef: data.transactionRef || "--",
                    webPayResponseDescription: data.webPayResponseDescription || "--",
                    gatewayResponseCode: data.gatewayResponseCode || "--",
                    dateOfPayment: data.dateOfPayment || "--",
                    qtSvaPrefix: data.qtSvaPrefix || "--",
                    isBillPayment: data.isBillPayment || "--",
                    isRecharge: data.isRecharge || "--",
                    isTransfer: data.isTransfer || "--",
                    currencyCode: data.currencyCode || "--",
                    trialCount: data.trialCount || "--",
                    webPayTransactionType: data.webPayTransactionType || "--",
                    minuteDiff: data.minuteDiff || "--",
                    prepaidCardNumber: data.prepaidCardNumber || "--",
                    channelId: data.channelId || "--",
                    qtResponseDescription: data.qtResponseDescription || "--",
                    repushCount: data.repushCount || "--",
                    repushResponseCode: data.repushResponseCode || "--",
                    isRepushable: data.isRepushable || "--",
                    channelFee: data.channelFee || "--",
                    reversalStatus: data.reversalStatus || "--",
                    reversalResponseDescription: data.reversalResponseDescription || "--",
                    isReversable: data.isReversable || "--",
                    sessionId: data.sessionId || "--",
                    batchReversalId: data.batchReversalId || "--",
                  };                  
            });

            const paginationData = {
                pageCount: response.data.pageCount,
                pageSize: response.data.pageSize,
                pageNo: response.data.pageNo,
                dataSize: response.data.dataSize,
            }
            callback(tableData);
            dispatch(saveBulkTransactionsByID(tableData));
            dispatch(savePaginationDataForViewBulkByID(paginationData));
        })
        .catch(function (error) {
            dispatch(setForBulkViewLoading(false));
            payload.failAction();
        });
}

export const savePortalUser = (payload) => dispatch => {
    dispatch({
        type: SAVE_PORTAL_USER,
        payload
    });
}

export const saveTransactions = (payload) => dispatch => {
    dispatch({
        type: GET_TRANSACTIONS,
        payload
    });
}

export const saveBulkTransactions = (payload) => dispatch => {
    dispatch({
        type: GET_BULK_TRANSACTIONS,
        payload
    });
}

export const saveBulkTransactionsByID = (payload) => dispatch => {
    dispatch({
        type: GET_BULK_TRANSACTIONS_BY_ID,
        payload
    });
}

export const saveSearchParam = (payload) => dispatch => {
    dispatch({
        type: SAVE_SEARCH_PARAM,
        payload
    });
}

export const savePaginationData = (payload) => dispatch => {
    dispatch({
        type: SAVE_PAGINATION_DATA,
        payload
    });
}

export const savePaginationDataForViewBulkByID = (payload) => dispatch => {
    dispatch({
        type: SAVE_PAGINATION_DATA_FOR_VIEW_BULK_BY_ID,
        payload
    });
}

//Loading
export const setLoading = (payload) => {
    return {
        type: LOADING,
        payload
    }
}

export const tableLoading = (payload) => {
    return {
        type: TABLE_LOADING,
        payload
    }
}

export const setForBulkViewLoading = (payload) => {
    return {
        type: BULK_VIEW_LOADING,
        payload
    }
}

